import { render, staticRenderFns } from "./BoardWriteBusinessLayout.vue?vue&type=template&id=2fd33782&scoped=true&"
import script from "./BoardWriteBusinessLayout.vue?vue&type=script&lang=js&"
export * from "./BoardWriteBusinessLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd33782",
  null
  
)

export default component.exports